// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".animated-line{content:\"\";height:2px;background:linear-gradient(90deg,var(--accent-blue) 50%,#000 0);background-size:200%;background-position:100% 100%;display:block;transition:all .2s ease}.animated-line.active{background-position:0 100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
